import React, { FC } from 'react';
import './ItvHeader.scss';
import MainLogo from './../../../assets/Itv/Win_White 1.svg';

export const ItvHeader: FC = () => {
  return (
    <header className="header">
      <img src={MainLogo} alt="logo" className="header__logo" />
    </header>
  );
};
